import { constantsData, formFieldNamesData } from "@/data";
import { AsyncDataKeyEnum, FieldTypeEnum } from "@/enums";

const { account } = constantsData.forms.accounts.moveToParent;

const { account: accountFieldName } = formFieldNamesData;

export const moveAccountToParentFormData = [
    {
        dataKey: AsyncDataKeyEnum.ACCOUNTS,
        description: account.description,
        isAsync: true,
        label: account.label,
        name: accountFieldName,
        type: FieldTypeEnum.SELECT,
    },
];
